// Admin dashboard page: a merged monthly-overview block, the yearly charts and
// the artist ranking, laid out responsively with Chakra grids.
import { Box, Grid, SimpleGrid } from "@chakra-ui/react";
import MonthOverviewCard from "./cards/MonthOverviewCard";
import ReservationDiagramCard from "./cards/ReservationDiagramCard";
import EventTypesCard from "./cards/EventTypesCard";
import UserBehaviorsCard from "./cards/UserBehaviorsCard";
import ArtistsRankingCard from "./cards/ArtistsRankingCard";

/**
 * Renders the admin dashboard: the merged monthly-overview card, the yearly
 * diagrams and the artist ranking side panel.
 * @returns {React.ReactElement}
 */
export default function Dashboard() {
  return (
    <Box>
      <Box mb="16px">
        <MonthOverviewCard />
      </Box>
      <Grid templateColumns={{ base: "1fr", xl: "2fr 1fr" }} gap="16px">
        <SimpleGrid columns={1} gap="16px">
          <ReservationDiagramCard />
          <EventTypesCard />
          <UserBehaviorsCard />
        </SimpleGrid>
        <ArtistsRankingCard />
      </Grid>
    </Box>
  );
}
